import { Link } from 'react-router-dom'
import StaffLoginForm from './components/StaffLoginForm'

export default function StaffLogin() {
  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-4 sm:px-8 py-10 sm:py-16">
        <Link to="/" className="flex items-center gap-3 mb-10 sm:mb-12">
          <img src="/Mufulira_Wanderers_logo.png" alt="Mufulira Wanderers" className="w-10 h-10 object-contain" />
          <span className="font-black text-gray-900 dark:text-white tracking-widest uppercase text-xl">MWFC</span>
        </Link>
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="text-xs text-green-600 dark:text-green-400 uppercase tracking-widest font-semibold mb-2">
              Staff Portal
            </div>
            <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
              Staff Sign In
            </h1>
            <p className="text-gray-500 text-sm">
              For club administrators and chapter coordinators only.
            </p>
          </div>
          <StaffLoginForm />
        </div>
      </div>
    </div>
  )
}